import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";

const Share = (props) => {
  const [theme, switchTheme] = useTheme();

  const [showShare, setShowShare] = useState();

  const [type, setType] = useState(1);

  const [showAlert, setShowAlert] = useState(false);

  const [alert, setAlert] = useState("");

  const [vitrinInput, setVitrinInput] = useState("");

  const [invited, setInvited] = useState([]);

  const [vCodeDelete, setVCodeDelete] = useState();

  const [showAlertDelete, setShowAlertDelete] = useState(false);

  const vitrinHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    } else {
      setVitrinInput(e.target.value);
    }
  };

  const changeType = (val) => {
    setType(val);
  };

  const addInvite = () => {
    const form = new FormData();
    form.append("type", "add");
    form.append("vCode", props.vitrinCode);
    form.append("vCodeInvite", vitrinInput);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/invitedVitrinApi.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAlert("ویترین با موفقیت افزوده شد");
        } else {
          setAlert(data.detail);
        }
        setShowAlert(true);
      })
      .catch((e) => {
        setAlert("اشکال در برقراری ارتباط با سرور");
        setShowAlert(true);
        console.log(e);
      });
  };

  const readInvited = () => {
    const form = new FormData();
    form.append("type", "read");
    form.append("vCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/invitedVitrinApi.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setInvited(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteInvited = () => {
    const form = new FormData();
    form.append("type", "delete");
    form.append("vCode", props.vitrinCode);
    form.append("vCodeInvite", vCodeDelete);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/invitedVitrinApi.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setAlert("ویترین با کد" + vCodeDelete + "با موفقیت حذف شد");
        } else {
          setAlert(data.detail);
        }
        setShowAlert(true);
      })
      .catch((e) => {
        setAlert("اشکال در برقراری ارتباط با سرور");
        setShowAlert(true);
        console.log(e);
      });
  };

  const show = () => {
    if (type === 1) {
      return (
        <div className="mt-3 text-center">
          <div className="form-lable">کد ویترین</div>
          <input
            className="form-control mt-1"
            value={vitrinInput}
            onChange={vitrinHandle}
            maxLength="6"
          />
          <button className="btn btn-success mt-2" onClick={addInvite}>
            ثبت درخواست
          </button>
        </div>
      );
    } else if (type === 2) {
      if (invited !== null) {
        if (invited[0] !== undefined) {
          return (
            <div>
              <table
                className={
                  theme === "light"
                    ? "table table-striped rtl text-dark"
                    : "table table-striped rtl text-light"
                }
              >
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">کد ویترین</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invited.map((item, index) => (
                  <tbody key={item.id}>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.vCode}</td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            setVCodeDelete(item.vCode);
                            setShowAlertDelete(true);
                          }}
                        >
                          حذف
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>

              <Modal
                show={showAlertDelete}
                onHide={() => setShowAlertDelete(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                scrollable
              >
                <Modal.Header
                  className={
                    theme === "light"
                      ? "bg-light text-dark rtl justify-content-center"
                      : "rtl justify-content-center bg-dark text-light"
                  }
                ></Modal.Header>
                <Modal.Body
                  className={
                    theme === "light"
                      ? "bg-light text-dark"
                      : "bg-dark text-light"
                  }
                >
                  <p className="m-2">
                    آیا ویترین {vCodeDelete} از لیست شما حذف گردد؟
                  </p>
                </Modal.Body>
                <Modal.Footer
                  className={
                    theme === "light"
                      ? "bg-light text-dark"
                      : "bg-dark text-light"
                  }
                >
                  <button
                    className="btn btn-success"
                    onClick={() => deleteInvited()}
                  >
                    بله
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => setShowAlertDelete(false)}
                  >
                    بستن
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
          );
        } else {
          return (
            <div className="row justify-content-center m-4">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          );
        }
      } else {
        return <div className="m-2">موردی ثبت نشده است</div>;
      }
    } else {
      return <div>type3</div>;
    }
  };

  return (
    <>
      <Nav.Link
        onClick={() => {
          setShowShare(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        اشتراک ویترین
      </Nav.Link>

      <Modal
        show={showShare}
        onHide={() => setShowShare(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          اشتراک ویترین
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="row rtl">
            <button
              onClick={() => {
                changeType(1);
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              ثبت درخواست
            </button>
            <button
              onClick={() => {
                changeType(2);
                readInvited();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              لیست درخواست ها
            </button>
            {/* <button
              onClick={() => {
                changeType(3);
              }}
              className={
                theme === "light" ? "btn btn-dark col-4" : "btn btn-light col-4"
              }
            >
              تایید شده ها
            </button> */}
          </div>
          {show()}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button className="btn btn-dark" onClick={() => setShowShare(false)}>
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAlert}
        onHide={() => {
          setShowAlert(false);
          setShowAlertDelete(false);
          setShowShare(false);
          setType(1);
          setVitrinInput("");
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {alert}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowAlert(false);
              setShowAlertDelete(false);
              setShowShare(false);
              setType(1);
              setVitrinInput("");
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Share;
